import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const tones = {
  neutral: "bg-slate-100 text-slate-700 ring-slate-900/5",
  brand: "bg-primary-soft text-brand-700 ring-brand-600/10",
  success: "bg-success-soft text-green-800 ring-green-700/10",
  warning: "bg-warning-soft text-amber-800 ring-amber-700/10",
  danger: "bg-danger-soft text-red-800 ring-red-700/10",
  premium: "bg-gradient-to-r from-amber-100 to-yellow-50 text-amber-900 ring-amber-600/20",
  dark: "bg-slate-900 text-white ring-slate-900",
  outline: "bg-white text-slate-700 ring-slate-900/10",
} as const;

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: keyof typeof tones;
  dot?: boolean;
}

export function Badge({ tone = "neutral", dot, className, children, ...props }: BadgeProps) {
  return (
    <span className={cn("inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-pill px-2.5 text-xs font-semibold ring-1 ring-inset [&_svg]:size-3.5", tones[tone], className)} {...props}>
      {dot ? <span className="size-1.5 rounded-full bg-current" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
